import { render } from "./PerfilUsuario.vue?vue&type=template&id=7fea7d24&scoped=true"
import script from "./PerfilUsuario.vue?vue&type=script&lang=js"
export * from "./PerfilUsuario.vue?vue&type=script&lang=js"

import "./PerfilUsuario.vue?vue&type=style&index=0&id=7fea7d24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fea7d24"]])

export default __exports__